import { render, staticRenderFns } from "./gotHome.vue?vue&type=template&id=5054dc66&scoped=true&"
import script from "./gotHome.vue?vue&type=script&lang=js&"
export * from "./gotHome.vue?vue&type=script&lang=js&"
import style0 from "./gotHome.vue?vue&type=style&index=0&id=5054dc66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5054dc66",
  null
  
)

export default component.exports